import { get, post } from '../../axiosprovider';
import { ITriggerRequest } from '@/models/schedule/triggerrequest';
import { IScheduledAction, IScheduledActionGroup } from '@/models';

const getAction = async (
	actionId: number,
	appointmentId: string
): Promise<IScheduledAction> => {
	return await get<IScheduledAction>(
		`/api/schedule/action/${actionId}/${appointmentId}`
	);
};

const getActions = async (
	page: number,
	query?: string
): Promise<IScheduledActionGroup[]> => {
	let url = `/api/schedule/actions/${page}`;
	if (query) {
		url += `?query=${query}`;
	}
	return await get<IScheduledActionGroup[]>(url);
};

const postTrigger = async (request: ITriggerRequest[]): Promise<void> => {
	return await post<ITriggerRequest[], void>(
		'/api/schedule/trigger',
		request
	);
};

export const scheduleController = {
	getAction,
	getActions,
	postTrigger
};
